export default "__VITE_ASSET__BymGbjV3__"